import Cookie from 'common/services/util/-RFC.Cookie';
/**
 * Controller for /dashboard/desktop route
 */
angular.module('controllers')
    .controller('ForceDesktop', ($state) => {

        const cookieConfig = CWCONFIG.cookie;
        const { domain } = cookieConfig;

        Cookie.set(cookieConfig.forceDesktop, true, { path: '/', domain });
        $state.go('root.dashboard.home', null, { location: 'replace' });

    });



// WEBPACK FOOTER //
// ./scripts/controllers/forceDesktop.js